<template>
  <div id="nav">
    <b-link to="/index" class="nav-title-first">首页</b-link>
    <b-link to="/order" class="nav-title">一键下单</b-link>
    <b-link to="/manufacturer" class="nav-title">品牌厂家</b-link>
    <b-link to="/union" class="nav-title">联盟品种</b-link>
    <b-link to="/quotation" class="nav-title">报价报量</b-link>
    <b-link to="/promotional" class="nav-title">商业促销</b-link>
  </div>
</template>
<script>
export default {

}
</script>
<style >
  #app {
  background-color: #f5f5f5;
  text-align: center;
  color: #2c3e50;
  min-width:1300px;
}
#nav {
  width: 100%;
  padding-bottom: 10px;
  border-bottom: solid 1px #ed1717
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
.nav-title{
  margin-left: 100px;
  font-weight: 400;
  font-size: 18px;
}
.nav-title-first{
  margin-left: -205px;
  font-weight: 400;
  font-size: 18px;
}
</style>
